export default [
  {
    disableBeacon: true,
    target: "#tour-dashboard-nav",
    title: "Get a holistic view of your compliance status",
    content: "Your compliance dashboard gives you a quick overview of your compliance status and allows you to track your team's progress in meeting your compliance goals.",
    placement: "right"
  },
  {
    target: "#tour-dashboard-top",
    title: "View relevant stats on your progress and gaps",
    content: "Here you'll have a breakdown of all actions that you've completed and what's outstanding so you can demonstrate your compliance progress.",
    placement: "bottom"
  },
  {
    target: "#tour-dashboard-bottom",
    title: "Keep in the Loop",
    content: "Use this section to get a bird's eye view of your team's training results and what they need to get done.",
    placement: "top"
  }
]


// WEBPACK FOOTER //
// ./src/components/tour/dashboard/steps.js